import { push } from '@lagunovsky/redux-react-router'
import { all, call, put, select, takeLatest } from 'redux-saga/effects'
import { callApiAsync } from 'services/api/callAPIAsync'
import { PATH_NAME } from '../../app/constants'
import { API_LANGUAGE_MAPPING } from '../../global/i18n/constants'
import { localeSelector } from '../../global/i18n/selectors'
import { getAccountOrders } from '../UserProfile/components/TicketsAndReserv/reducer'
import { VERIFY_PAYMENT_START } from './constants'
import { setFailReferenceNumber, setOrder } from './reducer'

export function* verifyPayment(verifyBody) {
    const language = API_LANGUAGE_MAPPING?.[yield select(localeSelector)] ?? null

    const { data: paymentVerifyData, error: paymentVerifyError } = yield call(callApiAsync, 'paymentVerify', verifyBody)

    if (paymentVerifyError) {
        console.error('verifyPaymentStartCallSaga', paymentVerifyError)
        yield put(push(`${PATH_NAME.PAYMENT_FAILED}`))
        return
    }

    const orderId = paymentVerifyData.orderid
    const paymentStatus = paymentVerifyData.payment_status
    const transactionId = paymentVerifyData.transactionid

    if (orderId < 0) {
        yield put(setFailReferenceNumber(paymentVerifyData.reference_number))
        yield put(push(`${PATH_NAME.PAYMENT_FAILED}`))
        return
    }

    //getting order
    const { data: orderData, error: orderError } = yield call(callApiAsync, 'orderGet', { language, orderid: orderId })

    if (orderError) {
        console.error('orderDataError', orderError)
        yield put(push(`${PATH_NAME.PAYMENT_FAILED}`))
        return
    }

    const transactionCinemaId = orderData.cinemaid

    yield put(setOrder(orderData))

    yield put(getAccountOrders())

    yield put(
        push(
            `${PATH_NAME.THANKS_FOR_ORDER}?orderid=${orderId}&payment_status=${paymentStatus}&transactionId=${transactionId}&transactionCinemaId=${transactionCinemaId}`
        )
    )
}

function* verifyPaymentStartCallSaga(action) {
    const verifyBody = action.data
    yield call(verifyPayment, verifyBody)
}

export default function* paymentVerifySaga() {
    yield all([takeLatest(VERIFY_PAYMENT_START, verifyPaymentStartCallSaga)])
}
